import { PapiUser } from '@wix/da-papi-types';
import { DeviationTypes, DeviationResourceType } from '../types/deviation';

export enum MediaPopupMode {
  MANAGER = 'manager',
  SELECTOR = 'selector',
}

export enum MediaSourceType {
  GALLERY = 'gallery', // must be lowercase to match gallection type
  COLLECTION = 'collection', // must be lowercase to match gallection type
  PRIVATE_COLLECTION = 'private_collection',
  STASH = 'stash',
  BROWSE = 'browse',
  CUSTOM_SET = 'custom_set',
  JOURNAL = 'journal',
  STATUS = 'status',
  POLL = 'poll',
  POSTS = 'posts',
  TIER = 'tier',
  TIER_DEVIATIONS = 'tier_deviations',
  TIER_POSTS = 'tier_posts',
  COMMISSIONS = 'commissions',
}

export interface MediaPopupStore {
  mode?: MediaPopupMode;
  currentFolderId?: number;
  currentSubfolderId?: number;
  currentTierId?: number;
  currentMediaSource?: MediaSourceType;
  searchInput: string;
  searchQuery?: string;
  selectedDeviationEntityIds: string[];
  selectionLimit?: number;
  allowGifs: boolean;
  allowPremium: boolean;
  allowInTierContent: boolean;
  allowDefaultImage: boolean;
  allowMature: boolean;
  allowUploads: boolean;
  allowMultipleUploads: boolean;
  isShowingNewGallectionPopup: boolean;
  isShowingAddDeviationsPopup: boolean;
  mediaSourceTypes?: MediaSourceType[];
  withMediaSourceSelector?: boolean;
  allowedDeviationTypes?: DeviationTypes[];
  allowedDeviationResourceTypes?: DeviationResourceType[];
  ignoreDeviationIds?: number[];
  minDeviationWidth?: number;
  minDeviationHeight?: number;
  gruser?: PapiUser;
}

export interface GallectionDeviationStreamParams {
  folderId?: number;
  mediaSource?: MediaSourceType;
  searchQuery?: string;
}

export interface GallectionStreamParams {
  mediaSource?: MediaSourceType;
  folderId?: number;
}

export interface PostStreamParams {
  type?: MediaSourceType;
}

export interface TierDeviationStreamParams {
  mediaSource?: MediaSourceType;
  tierId?: number;
}

export enum NotificationType {
  LABEL_AS = 'LABEL_AS',
}
